import { AnalyticAward } from 'components/award/voting/analytic-voting/AnalyticAward'
import { AnalyticVoting } from 'components/award/voting/analytic-voting/AnalyticVoting'
import { Voter } from 'components/award/voting/analytic-voting/Voter'
import { INITIAL_DATA_FILTER } from 'configs/award/configTableVoter'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { API_AWARD } from 'services/apiAward'
import { useFetch } from 'services/useFetch'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'

const VOTER_TAB = 'voter'
const CATEGORY_TAB = 'category'

export const AnalyticVotingContainer = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = { ...INITIAL_DATA_FILTER, ...getAllQueryParams(searchParams) }
    const [selectedCategory, setSelectedCategory] = useState()
    const [modal, setModal] = useState({
        export: false,
        preview: false,
    })
    const category = searchParams.get('category') || VOTER_TAB
    const id = searchParams.get('id')
    const { fetching: exportAnalytic, isLoading: isExporting } = useFetch({
        ...API_AWARD.AWARD_ANALYTIC_EXPORT,
        initPathVariable: id,
    })
    const { data: dataCategories } = useFetch(
        {
            ...API_AWARD.AWARD_ANALYTIC,
            initPathVariable: id,
        },
        { filteredBy: CATEGORY_TAB },
        { isFetching: true },
    )
    const {
        fetching: getDetailAnalytic,
        data: dataDetailAnalytic,
        isLoading,
    } = useFetch({
        ...API_AWARD.AWARD_ANALYTIC,
        initPathVariable: id,
    })
    const {
        fetching: getVoterDetail,
        data: dataVoterDetail,
        isLoading: isLoadingPreview,
    } = useFetch({
        ...API_AWARD.AWARD_ANALYTIC,
        initPathVariable: id,
    })

    useEffect(() => {
        if (selectedCategory) {
            fetchDetailAnalytic(query)
        }
    }, [selectedCategory])

    useEffect(() => {
        if (category && dataCategories?.data) {
            const findCategory = dataCategories?.data?.find((option) => option.name === category)
            if (findCategory) {
                setSelectedCategory(findCategory)
            } else {
                setSelectedCategory(VOTER_TAB)
            }
        }
    }, [category, dataCategories?.data])

    const optionsAwardList = useMemo(() => {
        const list = dataCategories?.data?.map((item) => item.name) || []
        list.unshift(VOTER_TAB)
        return list
    }, [dataCategories])

    const fetchDetailAnalytic = (currentQuery) => {
        const { category, id, ...newQuery } = currentQuery
        const payload = {
            ...INITIAL_DATA_FILTER,
            ...newQuery,
            filteredBy: category === VOTER_TAB ? category : CATEGORY_TAB,
            ...(selectedCategory?.id && { categoryId: selectedCategory?.id }),
        }
        getDetailAnalytic(payload)
    }

    const onChangeTab = (item) => {
        navigate(`/awards/voting/analytic?category=${item}${id ? `&id=${id}` : ''}`, { replace: true })
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
        fetchDetailAnalytic(params)
    }

    const onActionRow = (item) => {
        setModal({ ...modal, preview: true })
        getVoterDetail({
            filteredBy: VOTER_TAB,
            userId: item.id,
        })
    }

    const onExport = () => {
        const fileName = category === VOTER_TAB ? 'Voter' : `Category-${category}`
        exportAnalytic(
            {
                search: query.search,
                filtered_by: category === VOTER_TAB ? category : CATEGORY_TAB,
                ...(selectedCategory?.id && { category_id: selectedCategory?.id }),
            },
            '',
            {},
            'blob',
        ).then((response) => {
            downloadFile(null, response, `Analytic-${fileName}-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setModal({ ...modal, export: false })
        })
    }

    const propsContent = {
        data: dataDetailAnalytic?.data,
        dataPreview: dataVoterDetail?.data,
        query,
        onChangeQuery,
        isLoading,
        isLoadingPreview,
        onActionRow,
        setModal,
        modal,
    }

    const props = {
        options: optionsAwardList,
        activeTab: category || optionsAwardList[0],
        onChangeTab,
        setModal,
        modal,
        onExport,
        isExporting,
        totalResult: dataDetailAnalytic?.data?.total_result || '~',
        content: category === VOTER_TAB ? <Voter {...propsContent} /> : <AnalyticAward {...propsContent} />,
    }

    return <AnalyticVoting {...props} />
}
